import SessionTimeout from '~/api/session_timeout';

export default {
    async checkSession({ commit }) {
        commit('updateLoading', { sessionData: true });

        try {
            return await SessionTimeout.checkSession();
        } catch (error) {
            throw error;
        } finally {
            commit('updateLoading', { sessionData: false });
        }
    },

    async refreshSession({ commit }) {
        commit('updateLoading', { sessionData: true });

        try {
            return await SessionTimeout.refreshSession();
        } catch (error) {
            throw error;
        } finally {
            commit('updateLoading', { sessionData: false });
        }
    },
}